import { FC } from 'react'

import { composeClasses } from '@/utils/compose-classes'

export interface NavbarContainerProps {
  className?: string
  children: React.ReactNode
}
export const NavbarLeft: FC<NavbarContainerProps> = ({
  children,
  className
}) => {
  return (
    <div
      className={composeClasses(
        'items-center gap-6 flex-1 justify-start',
        className
      )}
    >
      {children}
    </div>
  )
}

export const NavbarRight: FC<NavbarContainerProps> = ({
  children,
  className
}) => {
  return (
    <div
      className={composeClasses(
        'flex items-center text-primary flex-1 justify-end gap-6',
        className
      )}
      data-testid="right-content"
    >
      {children}
    </div>
  )
}
